import React, { Fragment } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../theme/useDesignTokens";
import MuiDatePicker from "../Common/FormInputs/MuiDatePicker";
import { toNotificationExpiryEndOfDay } from "./notificationFormUtils";
import {
  emailFieldRowSx,
  emailFormControlSx,
  emailFocusOutlineSx,
  emailSectionCardSx,
} from "./emailFormStyles";

const EmailNotificationConfig = ({ expiryDate, onExpiryDateChange }) => {
  const theme = useTheme();
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;
  const focusOutlineSx = emailFocusOutlineSx(primaryColor);

  return (
    <Fragment>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
        Configuration
      </Typography>
      <Paper sx={emailSectionCardSx}>
        <Box sx={emailFieldRowSx}>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            Expiry:
          </Typography>
          <Box sx={{ ...emailFormControlSx(theme), ...focusOutlineSx }}>
            <MuiDatePicker
              label="Expiry Date"
              value={expiryDate ? new Date(expiryDate) : null}
              minDate={new Date()}
              onChange={(date) => onExpiryDateChange(date ? toNotificationExpiryEndOfDay(date) : null)}
            />
          </Box>
        </Box>
      </Paper>
    </Fragment>
  );
};

export default EmailNotificationConfig;
